/*
    * Get the duration between two dates in a human-readable format.
*/
export function getMaintenanceDuration(startTime, endTime) {
    if (!startTime || !endTime) return "";

    const start = new Date(startTime);
    const end = new Date(endTime);

    const diffMs = end - start;
    const totalMinutes = Math.round(diffMs / 60000);

    if (totalMinutes < 60) {
        const minLabel = totalMinutes === 1 ? "min" : "mins";
        return `${totalMinutes} ${minLabel}`;
    }

    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    const hrLabel = hours === 1 ? "hr" : "hrs";
    const minLabel = minutes === 1 ? "min" : "mins";

    return `${hours} ${hrLabel} ${minutes} ${minLabel}`;
}